import React from "react";
import { Navigate } from "react-router-dom";
import { getUserData } from "../../../services/apiService";
import { useUserData } from "../../../hooks/useUserData";
import { isSessionSuperAdmin } from "../../../utils/permissionUtils";
import ManageFaqModal from "../FAQ/ManageFaqModal";
import SuperAdminFaqAiPlatformSettings from "./SuperAdminFaqAiPlatformSettings";
import "../FAQ/FAQ.scss";

/**
 * AQ Super Admin — manage platform FAQs (CRUD + Excel import/export).
 * Separate from the public /faq read page.
 */
function SuperAdminFaqManagement() {
  const { userData, loading: userLoading } = useUserData();
  const sessionUser = userData || getUserData();
  const isSuperAdmin = isSessionSuperAdmin(sessionUser);
  const accessResolved = !userLoading || Boolean(sessionUser);

  if (!accessResolved) {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border" role="status" aria-label="Loading" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/notification-center" replace />;
  }

  return (
    <div className="user-mgmt-page user-mgmt-list-page super-admin-faq">
      <ManageFaqModal
        open
        asPage
        userData={sessionUser}
        onClose={() => {}}
        pageBanner={<SuperAdminFaqAiPlatformSettings />}
      />
    </div>
  );
}

export default SuperAdminFaqManagement;
